export const FLAGS = {
  DELETE_DOMAIN: 'can_delete_purchased_domain',
  SHOW_COLLECTIONS: 'showCollections',
  EMAIL_VERIFICATION: 'parEmailVerification'
};

export { useFeatureFlag } from './useFeatureFlag';
